import React, { useState, useEffect, useCallback } from 'react';
import { Loader2, Receipt, RefreshCw } from 'lucide-react';
import { apiClient } from '../../api/client';

const usd = (n) => `$${(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const CostOfGoodsTile = () => {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const [month, setMonth] = useState('');

  const load = useCallback(async (m) => {
    setBusy(true);
    try {
      const q = m ? `?month=${m}` : '';
      const r = await apiClient.request(`/api/admin/cogs/estimate${q}`);
      setData(r);
    } catch (e) {
      setData({ error: e.message });
    } finally {
      setBusy(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm" data-testid="cogs-tile">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Receipt size={18} className="text-rose-500" />
          <h3 className="font-bold text-gray-900">Cost of Goods (estimate)</h3>
          {data?.month && <span className="text-xs text-gray-400">{data.month}</span>}
        </div>
        <div className="flex items-center gap-2">
          <input
            type="month"
            value={month}
            onChange={(e) => { setMonth(e.target.value); load(e.target.value); }}
            className="text-xs border border-gray-200 rounded-lg px-2 py-1 text-gray-600"
            data-testid="cogs-month-picker"
          />
          <button onClick={() => load(month)} className="p-1.5 rounded-lg hover:bg-gray-100 text-gray-500" data-testid="cogs-refresh">
            {busy ? <Loader2 size={14} className="animate-spin" /> : <RefreshCw size={14} />}
          </button>
        </div>
      </div>

      {!data ? (
        <div className="py-8 text-center text-gray-400"><Loader2 size={20} className="animate-spin mx-auto" /></div>
      ) : data.error ? (
        <p className="text-sm text-red-600">{data.error}</p>
      ) : (
        <>
          <p className="text-3xl font-bold text-gray-900 mb-4" data-testid="cogs-total">{usd(data.total_est_usd)}<span className="text-sm font-normal text-gray-400"> / month est.</span></p>
          <div className="space-y-1.5">
            {data.lines.map((l) => (
              <div key={l.key} className="flex items-center justify-between text-xs px-3 py-2 rounded-lg bg-gray-50" data-testid={`cogs-line-${l.key}`} title={l.assumption}>
                <span className="text-gray-700 font-medium">{l.label} <span className="text-gray-400">· {l.provider}</span></span>
                <span className="text-gray-500">{l.count.toLocaleString()} × {usd(l.unit_cost_usd)} = <strong className="text-gray-900">{usd(l.est_cost_usd)}</strong></span>
              </div>
            ))}
          </div>
          <p className="text-[11px] text-gray-400 mt-3 leading-relaxed">{data.fixed_costs_note}</p>
        </>
      )}
    </div>
  );
};

export default CostOfGoodsTile;
